import { constants } from '@/config';

export function getRuntimeEnv() {
  return constants.ENV;
}

export function isDemoEnvironment(env = getRuntimeEnv()) {
  return env === 'demo';
}
